<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap pb-5>
					<v-flex xs12 sm6
						pl-4 pr-5 pt-5>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Nombre"
									required
									v-model="$v.model.nombreComercial.$model"
									:error="$v.model.nombreComercial.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Razón Social"
									required
									v-model="$v.model.razonSocial.$model"
									:error="$v.model.razonSocial.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Código"
									required
									v-model="$v.model.codeCompany.$model"
									:error="$v.model.codeCompany.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Ruc"
									required
									type="number"
									v-model="$v.model.ruc.$model"
									:error="$v.model.ruc.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-select
								background-color="white"
								class="body-1 mt-2"
								box
								hide-details
								item-text="name"
								item-value="id"
								label="Template"
								:items="listTemplate"
								v-model="$v.model.idTemplate.$model"
								:error="$v.model.idTemplate.$error"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
								background-color="white"
								box
								class="body-1"
								hide-details
								item-text="name"
								item-value="id"
								label="Distribuidores"
								:items="listDistributors"
								v-model="model.idDistributor"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
								box
								background-color="white"
								class="body-1"
								hide-details
								label="País"
								item-text="name"
								item-value="id"
								:items="countries"
								v-model="$v.model.countryId.$model"
								:error="$v.model.countryId.$error"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3>
							<span v-if="companyId">
								<v-text-field
									background-color="white"
									box
									:disabled="this.mode === 'edit'"
									class="body-1"
									hide-details
									label="Rubro"
									required
									v-model="model.nameRubro"
								>
								</v-text-field>
								<!-- <label>Rubro: {{ model.rubroId }}</label> -->
							</span>
							<v-select
								v-else
								box
								background-color="white"
								class="body-1"
								hide-details
								label="Rubro"
								item-text="name"
								item-value="id"
								:items="rubros"
								v-model="model.idItem"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
								box
								background-color="white"
								class="body-1"
								hide-details
								label="Planes"
								item-text="name"
								item-value="id"
								:items="plans"
								v-model="model.typePlan"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Dominio"
									required
									v-model="model.domain"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs2
								v-for="(language, key) in languagesByProject"
								:key="key">
								<v-checkbox
									color="success"
									v-model="language.isSelected"
									hide-details
									:label="language.id"
									@change="selectLanguages(language, key)">
								</v-checkbox>
							</v-flex>
							<v-flex xs12>
								<v-checkbox
										color="success"
										label="Restringir accesos web services"
										v-model="model.flagAllowAccess"
									>
								</v-checkbox>
							</v-flex>
							<v-flex xs5 pr-3>
								<v-flex xs12>
									Fecha de facturación
								</v-flex>
								<date-component
									:date="date"
									@on-input="setDate({ model: 'dateBilling', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8 mb-1>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Semana de facturación"
									required
									v-model="model.billingWeek"
									@input="filterInput"
								>
								</v-text-field>
								<span class="error--text caption" v-if="model.billingWeek && !isAlphaNumeric">Solo se permiten caracteres alfanuméricos.</span>
							</v-flex>
							<v-flex mb-2 xs8>
								<v-layout row align-center>
									<v-flex xs10 class="title-validations">
										Bloquear el ingreso de compañias
									</v-flex>
									<v-flex xs2>
										<v-switch
											class="mt-0"
											color="base"
											hide-details
											v-model="model.flagBlocked"
										></v-switch>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<label class="title-form pl-2">INTEGRAR APLICACIONES</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex mb-2 xs12 v-for="(item, index) in model.settings.serviceExternal" :key="index">
								<v-layout row align-center>
									<v-flex xs2>
										<v-switch
										class="mt-0"
										color="base"
										hide-details
										v-model="item.flagSelected"
										@change="changeState(index)"
										></v-switch>
									</v-flex>
									<v-flex xs10 class="title-validations">
										{{ item.title }}
									</v-flex>
								</v-layout>
								<v-layout column v-if="item.open">
									<v-flex xs12 mb-2>
										<label :ref="`json-${index}`" :for="`json-id-${index}`">
											<vue-six-four :id="`json-id-${index}`" hidden @vue-six-four="getFile($event, index)"/>
											<v-layout wrap>
												<v-flex xs10>
													<v-text-field
													box
													class="body-1 mb-3"
													label="Credencial"
													background-color="white"
													hide-details
													readonly
													v-model="item.credential">
													</v-text-field>
												</v-flex>
												<v-flex xs2 text-xs-left mt-3>
													<v-btn
													class="btn-action caption"
													color="base"
													@click="showDialog(`json-${index}`)"
													>Adjuntar Archivo</v-btn>
												</v-flex>
											</v-layout>
										</label>
									</v-flex>
									<v-flex xs12>
										<v-text-field
										box
										class="body-1 mb-3"
										label="URL"
										v-model="item.databaseURL"
										background-color="white"
										hide-details
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 sm6 pr-4 pl-5 pb-5>
						<v-layout wrap align-center>
							<v-flex xs12>
								<label class="title-form pl-2">LISTA DE MÓDULOS</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12 mb-3>
								<label class="title-form pl-2">Selecciona los módulos para tu compañía</label>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									:items="apps"
									item-text="name"
									item-value="codeApp"
									label="Aplicaciones"
									v-model="codeApp"
									@input="loadModules"
								></v-select>
							</v-flex>
						</v-layout>
						<v-layout
							wrap
							v-for="module in modules"
							:key="module.id"
						>
							<v-checkbox
								slot="header"
								class="pl-4 mt-0"
								color="success"
								height="48"
								hide-details
								:disabled="expandDisabled"
								:label="module.name"
								v-model="module.isSelected"
								@change="removeModelModule(module)">
							</v-checkbox>
							<v-slide-y-transition>
								<v-flex xs12 v-if="module.isSelected">
									<v-layout row wrap align-center
										v-for="(language, key) in module.languages"
										:key="key">
										<v-flex xs2 text-xs-right>
											<img src="" alt="">
											<label>{{ language.id }}</label>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												background-color="white"
												box
												class="body-1"
												hide-details
												label="Nombre"
												required
												v-model="language.name"
											>
											</v-text-field>
										</v-flex>
									</v-layout>
									<v-layout wrap align-center px-5>
										<v-flex xs12 sm4>
											<label>Posición</label>
										</v-flex>
										<v-flex xs12 sm5 pr-4>
											<v-text-field
												background-color="white"
												box
												class="body-1"
												hide-details
												type="number"
												min="1"
												label="Posición"
												v-model.number="module.position"
												@input="setPosition(module)"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs12 sm4 pr-0>
											<upload-image
												:label-ref="`${module.id}-up`"
												:label-for="`${module.id}-image`"
												:input-id="`${module.id}-image`"
												:item-update="module"
												@send-image="sendImage"
											/>
										</v-flex>
										<v-flex xs12 sm8>
											<v-text-field
												solo
												class="body-1"
												hide-details
												label="Icono"
												v-model="module.pathIcon"
											>
											</v-text-field>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-slide-y-transition>
						</v-layout>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading || !isAlphaNumeric"
						:on-run-service="loading"
						success-text="Grabar"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
	import { format } from 'date-fns';
	import VueSixFour from 'vue-six-four';
	import { required } from 'vuelidate/lib/validators';
	import uploadImage from '@/components/shared/upload-image';
	import dateComponent from '@/components/shared/date-component-admin';

	const PAGE_COMPANY_LIST = 'page-company';

	async function getFile(fileInfo, index) {
		const newfile = {
			name: fileInfo.name.replace(/\s/g, '-'),
			base64data: fileInfo.sixFour,
		};
		const words = newfile.name.split('.');
		const lastItem = words.length;
		const extension = words[lastItem - 1];
		if (this.allowedFiles.indexOf(extension) > -1) {
			this.model.settings.serviceExternal[index].credential = newfile.base64data;
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	}

	function showDialog(prop) {
		this.$refs[prop][0].click();
	}

	function changeState(index) {
		this.model.settings.serviceExternal[index].open =
			!this.model.settings.serviceExternal[index].open;
	}

	async function created() {
		if (this.mode === 'edit') {
			const { data: record } = await this.$http.get(`company/${this.companyId}`);
			if (record.data) {
				this.model = {
					idTemplate: record.data.templateId,
					idDistributor: record.data.distributorId,
					idItem: record.data.idItem,
					billingWeek: record.data.billingWeek,
					dateBilling: record.data.dateBilling ? format(new Date(record.data.dateBilling), 'DD/MM/YYYY') : undefined,
					nombreComercial: record.data.nombreComercial,
					razonSocial: record.data.razonSocial,
					codeCompany: record.data.codeCompany,
					ruc: record.data.ruc,
					languages: record.data.languages,
					modules: [],
					flagBlocked: record.data.flagBlocked,
					domain: record.data.domain,
					settings: record.data.settings,
					countryId: record.data.country ? record.data.country.data.id : undefined,
					flagAllowAccess: record.data.flagAllowAccess === 1,
					typePlan: record.data.typePlan || null,
				};
				this.date = record.data.dateBilling ? format(new Date(record.data.dateBilling), 'YYYY-MM-DD') : undefined;
				const serviceExternal = this.model.settings.serviceExternal;
				if (serviceExternal && serviceExternal.length === 0) {
					this.model.settings.serviceExternal = [...this.arrayDefault];
				} else {
					this.appMerge();
				}
				this.model.settings.serviceExternal =
					record.data.settings ? record.data.settings.serviceExternal : [];
				this.languagesByProject = record.data.languages;
			}
		} else {
			this.model.settings.serviceExternal = [...this.arrayDefault];
		}
		this.loadApps();
		this.loadTemplate();
		this.loadDistributors();
		this.loadCountries();
		this.loadItems();
		const response = await this.$http.get('type-plans');
		this.plans = response.data.data;
	}

	async function loadItems() {
		try {
			const url = `project/${this.codeProject}/items`;
			const { data: items } = await this.$http.get(url);
			({ data: this.rubros } = items);
			const findItem = this.rubros.find(p => p.itemId === this.model.idItem);
			this.model.nameRubro = findItem.name;
		} catch (error) {
			this.showError();
		}
	}

	async function loadCountries() {
		try {
			const response = await this.$http.get('countries');
			this.countries = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	function appMerge() {
		const newApps = this.arrayDefault.reduce((acum, item) => {
			const modelIndex = this.model.settings.serviceExternal && this.model.settings.serviceExternal.findIndex(
				se => se.title === item.title);
			if (modelIndex < 0) {
				acum.push(item);
			}
			return acum;
		}, []);
		this.model.settings.serviceExternal =
			this.model.settings.serviceExternal && this.model.settings.serviceExternal.concat(newApps);
	}

	async function loadTemplate() {
		const params = {
			page: 1,
		};
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		try {
			const response = await this.$http.get(`project/${this.codeProject}/template`, { params, headers });
			this.listTemplate = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	async function loadDistributors() {
		try {
			const response = await this.$http.get('distributaries');
			this.listDistributors = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	function closeModal() {
		const codeProject = this.codeProject;
		this.goTo(PAGE_COMPANY_LIST, { params: { codeProject } });
	}

	function expandDisabled() {
		let disabled = true;
		const languagesKeys = Object.keys(this.languagesByProject);
		languagesKeys.forEach((key) => {
			if (this.languagesByProject[key].isSelected) {
				disabled = false;
			}
		});
		return disabled;
	}

	async function loadApps() {
		try {
			const { data: apps } = await this.$http.get(`project/${this.codeProject}/apps`);
			this.apps = apps.data;
			this.codeApp = this.apps[0].codeApp;
			this.loadModules(this.codeApp);
		} catch (err) {
			this.showError();
		}
	}

	async function loadLanguages() {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		try {
			const { data: project } = await this.$http.get(`projects/${this.codeProject}`, { headers });
			const projectLanguages = project && project.data && project.data.languages ?
				project.data.languages : {};
			const lang = {};
			Object.keys(projectLanguages).forEach((pLangKey) => {
				if (projectLanguages[pLangKey].isSelected) {
					projectLanguages[pLangKey].isSelected = false;
					lang[pLangKey] = projectLanguages[pLangKey];
				}
			});
			this.languagesByProject = { ...lang };
		} catch (err) {
			this.showError();
		}
	}

	async function loadModules(code) {
		const query = {
			params: {
				codeCompany: this.mode === 'edit' ? this.codeCompany : null,
				codeProject: this.mode === 'edit' ? this.codeProject : null,
			},
			headers: {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			},
		};
		try {
			const { data: modulesData } = await this.$http.get(`app/${code}/modules`, query);
			this.modules = modulesData.data.map((module) => {
				const newModule = { ...module };
				const index = this.model.modules.findIndex(modMod => modMod.id === module.id);
				newModule.languages = {};
				newModule.isSelected = false;
				if (this.companyId && module.configLanguages) {
					newModule.languages = { ...module.configLanguages.languages };
					newModule.isSelected = true;
					newModule.pathIcon = module.configLanguages.pathIcon;
					newModule.position = module.configLanguages.position;
					delete newModule.configLanguages;
					if (index < 0) {
						this.model.modules.push(newModule);
					}
				} else if (this.model.modules.length > 0) {
					if (index < 0) {
						this.model.modules.push(newModule);
					} else {
						newModule.isSelected = this.model.modules[index].isSelected;
						newModule.languages = this.model.modules[index].languages;
						newModule.pathIcon = this.model.modules[index].pathIcon;
						newModule.position = this.model.modules[index].position;
					}
				} else {
					this.model.modules.push(newModule);
				}
				return newModule;
			});
			let languagesEmpty = true;
			Object.keys(this.languagesByProject).forEach((key) => {
				if (this.languagesByProject[key]) {
					languagesEmpty = false;
				}
			});
			if (!this.companyId && languagesEmpty) {
				this.loadLanguages();
			} else {
				Object.keys(this.languagesByProject).forEach((key) => {
					if (this.languagesByProject[key].isSelected) {
						this.selectLanguages(this.languagesByProject[key], key);
					}
				});
			}
			this.panel = this.modules.map(mod => mod.isSelected);
		} catch (err) {
			this.showError();
		}
	}

	function mode() {
		return this.companyId ? 'edit' : 'create';
	}

	function modelModulesEmpty() {
		return this.model.modules.every(modMod => !modMod.isSelected);
	}

	function removeModelModule(mod) {
		if (!mod.isSelected) {
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				if (modModule.id === mod.id) {
					newModModule.isSelected = false;
				}
				return newModModule;
			});
		} else {
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				if (modModule.id === mod.id) {
					newModModule.isSelected = true;
				}
				return newModModule;
			});
		}
	}

	function selectLanguages({ id, isSelected }, key) {
		if (isSelected) {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				if (!module.configLanguages && !module.languages[key]) {
					const newLanguage = { id, name: '' };
					newModule.languages[key] = newLanguage;
				}
				return newModule;
			});
			this.model.modules = this.model.modules.map((modMod) => {
				const newModMod = { ...modMod };
				if (!modMod.configLanguages && !modMod.languages[key]) {
					const newModLanguage = { id, name: '' };
					newModMod.languages[key] = newModLanguage;
				}
				return newModMod;
			});
		} else if (this.expandDisabled) {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				newModule.isSelected = false;
				delete newModule.languages[key];
				return newModule;
			});
			this.model.modules = this.model.modules.map((mod) => {
				const newMod = { ...mod };
				newMod.isSelected = false;
				delete newMod.languages[key];
				return newMod;
			});
		} else {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				delete newModule.languages[key];
				return newModule;
			});
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				delete newModModule.languages[key];
				return newModModule;
			});
		}
	}

	function sendImage({ urlImage, item }) {
		this.modules = this.modules.map((mod) => {
			const newMod = { ...mod };
			if (item.id === mod.id) {
				newMod.pathIcon = urlImage;
			}
			return newMod;
		});
		this.model.modules = this.model.modules.map((modModule) => {
			const newModModule = { ...modModule };
			if (item.id === modModule.id) {
				newModModule.pathIcon = urlImage;
			}
			return newModModule;
		});
	}

	function setPosition(module) {
		const { position } = module;
		const indexMod = this.model.modules.findIndex(mod => mod.id === module.id);
		this.model.modules[indexMod].position = position;
	}

	async function submitForm() {
		if (this.mode === 'create') {
			this.model.languages = this.languagesByProject;
		}
		this.model.settings.serviceExternal = this.model.settings.serviceExternal ?
		this.model.settings.serviceExternal.filter(c => c.flagSelected) : null;
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const method = this.mode === 'create' ? 'post' : 'put';
		const url = this.mode === 'create' ? `company/${this.codeProject}/project` : `company/${this.codeCompany}`;
		if (this.mode === 'edit') {
			this.model.codeProject = this.codeProject;
			this.model.flagAllowAccess = Number(this.model.flagAllowAccess);
		}

		this.model.billingWeek = this.model.billingWeek ? Number(this.model.billingWeek) : null;
		this.model.dateBilling = this.model.dateBilling ? new Date(this.model.dateBilling.split('/').reverse().join('-')).toISOString().split('T')[0] : null;
		this.loading = true;
		try {
			await this.$http[method](url, this.model, { headers });
			this.showNotification('La información de la compañía se guardó correctamente.');
			this.goTo('page-company');
			if (this.mode === 'create') {
				this.goTo('page-company');
			}
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === 'MODULE_HAS_ASSOCIATED_DATA') {
					this.showError('Los módulos con permisos asignados deben ser seleccionados para poder grabar la información.',
						'info');
				}
			} else {
				this.showError();
			}
		} finally {
			this.loading = false;
		}
	}

	function validations() {
		const validation = {
			model: {
				nombreComercial: {
					required,
				},
				razonSocial: {
					required,
				},
				codeCompany: {
					required,
				},
				ruc: {
					required,
				},
				idTemplate: {
					required,
				},
				countryId: {
					required,
				},
			},
		};
		return validation;
	}

	function data() {
		return {
			open: false,
			listDistributors: [],
			allowedFiles: ['json'],
			apps: [],
			codeApp: '',
			countries: [],
			languagesByProject: {},
			listTemplate: [],
			loading: false,
			arrayDefault: [
				{
					id: 1,
					title: 'FIREBASE',
					flagSelected: false,
					typeId: 1,
					databaseURL: null,
					credential: null,
					open: false,
				},
				{
					id: 2,
					title: 'NETLIFY',
					flagSelected: false,
					typeId: 2,
					databaseURL: null,
					credential: null,
					open: false,
				},
			],
			model: {
				nombreComercial: '',
				dateBilling: '',
				billingWeek: null,
				flagBlocked: false,
				razonSocial: '',
				codeCompany: '',
				countryId: null,
				domain: null,
				nameRubro: '',
				typePlan: null,
				idTemplate: null,
				idDistributor: null,
				ruc: '',
				languages: {},
				modules: [],
				idItem: null,
				settings: {
					serviceExternal: [
						{
							id: 1,
							title: 'FIREBASE',
							flagSelected: false,
							typeId: 1,
							databaseURL: null,
							credential: null,
							open: false,
						},
						{
							id: 2,
							title: 'NETLIFY',
							flagSelected: false,
							typeId: 2,
							databaseURL: null,
							credential: null,
							open: false,
						},
					],
				},
			},
			module: {},
			modules: [],
			panel: [],
			plans: [],
			rubros: [],
			date: '',
			isAlphaNumeric: true,
		};
	}

	export default {
		name: 'company-form',
		components: {
			uploadImage,
			VueSixFour,
			dateComponent,
		},
		computed: {
			expandDisabled,
			mode,
			modelModulesEmpty,
		},
		created,
		data,
		methods: {
			changeState,
			closeModal,
			getFile,
			appMerge,
			loadApps,
			loadCountries,
			loadDistributors,
			loadItems,
			loadLanguages,
			loadModules,
			loadTemplate,
			removeModelModule,
			selectLanguages,
			setPosition,
			sendImage,
			showDialog,
			submitForm,
			setDate({ model, value }) {
				this.model[model] = format(value, 'DD/MM/YYYY');
				this.date = value;
			},
			filterInput(event) {
				this.isAlphaNumeric = /^[a-zA-Z0-9]*$/.test(event);
				// this.model.billingWeek = event.replace(/[^a-zA-Z0-9]/g, '');
			},
		},
		props: {
			codeProject: {
				type: String,
			},
			companyId: {
				type: [Number, String],
			},
			codeCompany: {
				type: String,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.expansion-panel-modules {
		box-shadow: none;
		padding-bottom: 60px;

		.v-expansion-panel__header {
			padding: 0px 24px;
		}

		.v-input {
			margin-top: 0px;
		}

		.v-label {
			height: 100%;
			width: 100%;
		}
	}

	.expansion-disabled-modules {
		opacity: .6;
		pointer-events: none;
	}

	.title-validations {
		color: map-get($colors, base);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/components/companies/company-form.vue